import { notification } from 'antd'
import axios from '../axios'
import userPool from '../userpool'

export async function get(url) {
  const cognitoUser = userPool.getCurrentUser()
  function getCurrentUser() {
    return new Promise((resolve, reject) => {
      cognitoUser.getSession((err, session) => {
        if (err) {
          reject(err)
        }
        axios
          .get(url, {
            headers: {
              Authorization: `${session.idToken.jwtToken}`,
            },
          })
          .then((response) => {
            resolve(response.data)
          })
          .catch(() => {
            resolve(false)
          })
      })
    })
  }
  if (cognitoUser != null) return getCurrentUser()

  return false
}

export async function post(url, payload, successMessage = 'Success', errorMessage = 'Error') {
  const cognitoUser = userPool.getCurrentUser()
  return new Promise((resolve, reject) => {
    cognitoUser.getSession((err, session) => {
      if (err) {
        reject(err)
      }
      axios
        .post(
          url,
          { ...payload },
          {
            headers: {
              Authorization: session.idToken.jwtToken,
            },
          },
        )
        .then(() => {
          notification.success({ message: successMessage })
          resolve(true)
        })
        .catch((err) => {
          notification.error({ message: err?.response?.data || errorMessage })
          resolve(false)
        })
    })
  })
}

export async function getAdminViaData(url, data) {
  const cognitoUser = userPool.getCurrentUser()
  function getCurrentUser() {
    return new Promise((resolve, reject) => {
      cognitoUser.getSession((err, session) => {
        if (err) {
          reject(err)
        }
        axios
          .get(url, {
            headers: {
              Authorization: `${session.idToken.jwtToken}`,
            },
            params: data.payload, // Send data as query parameters
          })
          .then((response) => {
            let data = response.data;
            console.log('Raw response.data:', data);

            if (data) {
              if (typeof data.body === 'string') {
                try {
                  const parsed = JSON.parse(data.body);
                  console.log('Parsed body:', parsed);
                  resolve(parsed);
                  return;
                } catch (e) {
                  console.error('Failed to parse response body:', e, data.body);
                }
              } else if (Array.isArray(data)) {
                console.log('Response is already an array');
                resolve(data);
                return;
              } else if (data.body && Array.isArray(data.body)) {
                console.log('Response.body is an array');
                resolve(data.body);
                return;
              }
            }

            console.log('Admin VIA Data (final):', data);
            resolve(data);
          })
          .catch((err) => {
            if (err?.response?.data) {
              let errorData = err.response.data;

              if (errorData && typeof errorData.body === 'string') {
                try {
                  errorData = JSON.parse(errorData.body);
                } catch (e) {
                  console.error('Failed to parse error response body:', e);
                }
              }

              resolve(errorData)
            } else {
              resolve(false)
            }
          })
      })
    })
  }
  if (cognitoUser != null) return getCurrentUser()

  return false
}

// GET /admin/aura/missions with query params
export async function getViaMissions(params) {
  const cognitoUser = userPool.getCurrentUser()
  function getCurrentUser() {
    return new Promise((resolve) => {
      cognitoUser.getSession((err, session) => {
        if (err) {
          notification.error({ message: 'Session expired. Please login again.' })
          resolve(false)
          return
        }
        axios
          .get('/admin/aura/missions', {
            headers: {
              Authorization: `${session.idToken.jwtToken}`,
            },
            params,
          })
          .then((response) => {
            resolve(response.data)
          })
          .catch((err) => {
            const message = err?.response?.data || 'Error fetching missions'
            notification.error({ message })
            resolve(false)
          })
      })
    })
  }
  if (cognitoUser != null) return getCurrentUser()

  return false
}

// POST /admin/aura/missions to create a mission
export async function createViaMission(payload) {
  const cognitoUser = userPool.getCurrentUser()
  function getCurrentUser() {
    return new Promise((resolve) => {
      cognitoUser.getSession((err, session) => {
        if (err) {
          notification.error({ message: 'Session expired. Please login again.' })
          resolve(false)
          return
        }
        axios
          .post('/admin/aura/missions', payload, {
            headers: {
              Authorization: `${session.idToken.jwtToken}`,
            },
          })
          .then((response) => {
            notification.success({ message: 'Mission created' })
            resolve(response.data)
          })
          .catch((err) => {
            const messageText = err?.response?.data || 'Error creating mission'
            notification.error({ message: messageText })
            resolve(false)
          })
      })
    })
  }
  if (cognitoUser != null) return getCurrentUser()

  notification.error({ message: 'Not logged in. Please login first.' })
  return false
}

// PUT /admin/aura/missions to update a mission
export async function updateViaMission(payload) {
  const cognitoUser = userPool.getCurrentUser()
  function getCurrentUser() {
    return new Promise((resolve) => {
      cognitoUser.getSession((err, session) => {
        if (err) {
          notification.error({ message: 'Session expired. Please login again.' })
          resolve(false)
          return
        }
        axios
          .put('/admin/aura/missions', payload, {
            headers: {
              Authorization: `${session.idToken.jwtToken}`,
            },
          })
          .then((response) => {
            notification.success({ message: 'Mission updated' })
            resolve(response.data)
          })
          .catch((err) => {
            const messageText = err?.response?.data || 'Error updating mission'
            notification.error({ message: messageText })
            resolve(false)
          })
      })
    })
  }
  if (cognitoUser != null) return getCurrentUser()

  notification.error({ message: 'Not logged in. Please login first.' })
  return false
}

// DELETE /admin/aura/missions to delete a mission
export async function deleteViaMission(payload) {
  const cognitoUser = userPool.getCurrentUser()
  function getCurrentUser() {
    return new Promise((resolve) => {
      cognitoUser.getSession((err, session) => {
        if (err) {
          notification.error({ message: 'Session expired. Please login again.' })
          resolve(false)
          return
        }
        axios
          .delete('/admin/aura/missions', {
            headers: {
              Authorization: `${session.idToken.jwtToken}`,
            },
            data: payload,
          })
          .then((response) => {
            notification.success({ message: 'Mission deleted successfully' })
            resolve(response.data)
          })
          .catch((err) => {
            const messageText = err?.response?.data || 'Error deleting mission'
            notification.error({ message: messageText })
            resolve(false)
          })
      })
    })
  }
  if (cognitoUser != null) return getCurrentUser()

  notification.error({ message: 'Not logged in. Please login first.' })
  return false
}

// GET /admin/aura/studies with query params mapped to client-side sorting/filtering
export async function getViaStudies(params) {
  const cognitoUser = userPool.getCurrentUser()
  function getCurrentUser() {
    return new Promise((resolve) => {
      cognitoUser.getSession((err, session) => {
        if (err) {
          notification.error({ message: 'Session expired. Please login again.' })
          resolve(false)
          return
        }

        const sortMap = {
          'study_id': 'studyId',
          'int_ref': 'companyCode',
          'complete': 'complete',
          'start_date': 'startDate',
          'end_date': 'endDate',
        }
        const mappedSortBy = sortMap[params.sortBy] || 'studyId'

        // Map UI params to API expected params
        const apiParams = {
          page: params.page || 1,
          pageSize: params.pageSize || 20,
          sortBy: mappedSortBy,
          sortDir: params.sortDir || 'asc',
          q: params.q || undefined,
        }

        if (params.study_id) apiParams.studyId = params.study_id
        if (params.complete !== undefined) apiParams.complete = params.complete === 1
        if (params.recruitment_done !== undefined) apiParams.recruitmentDone = params.recruitment_done === 1

        axios
          .get('/admin/aura/studies', {
            headers: {
              Authorization: `${session.idToken.jwtToken}`,
            },
            params: apiParams,
          })
          .then((response) => {
            const data = response.data || {}
            const rawItems = data.items || []

            // Map backend DynamoDB fields to UI expected structure
            let items = rawItems.map((item) => {
              const studyInfo = item.studyInfo || {}
              return {
                study_id: item.studyId || '',
                int_ref: studyInfo.companyCode || studyInfo.intRef || '',
                complete: item.complete ? 1 : 0,
                recruitment_done: item.recruitmentDone ? 1 : 0,
                report_url: studyInfo.reportUrl || '',
                report_view_only: studyInfo.reportViewOnly ? 1 : 0,
                start_date: studyInfo.startDate || '',
                end_date: studyInfo.endDate || '',
                
                // Map new fields
                description: studyInfo.description || '',
                joinByDate: studyInfo.joinByDate || '',
                logo: studyInfo.logo || '',
                orgName: studyInfo.orgName || '',
                reward: studyInfo.reward || '',
                studyInstructions: studyInfo.studyInstructions || '',
                studyName: studyInfo.studyName || '',
                termsLink: studyInfo.termsLink || '',
                useOfData: studyInfo.useOfData || '',
                
                emailReminders: studyInfo.emailReminders === true,
                missionReminders: studyInfo.missionReminders === true,
                st: studyInfo.st === true,
                
                missionReminders_root: item.missionReminders === true,
                welcomEmailReminder: item.welcomEmailReminder === true,
                
                endOfStudyConditions: studyInfo.endOfStudyConditions,
                userRequiredDevices: studyInfo.userRequiredDevices,
                dataConnections: studyInfo.dataConnections,
                licenses: item.licenses,
                
                raw: item,
              }
            })

            resolve({
              items: items,
              total: data.total || items.length,
            })
          })
          .catch((err) => {
            const message = err?.response?.data || 'Error fetching studies'
            notification.error({ message })
            resolve(false)
          })
      })
    })
  }
  if (cognitoUser != null) return getCurrentUser()

  return false
}

// POST /admin/aura/studies
export async function createViaStudy(payload) {
  const cognitoUser = userPool.getCurrentUser()
  function getCurrentUser() {
    return new Promise((resolve) => {
      cognitoUser.getSession((err, session) => {
        if (err) {
          notification.error({ message: 'Session expired. Please login again.' })
          resolve(false)
          return
        }

        const apiPayload = {
          studyId: payload.study_id,
          companyCode: payload.int_ref || '',
          complete: payload.complete === 1,
          startDate: payload.start_date || null,
          endDate: payload.end_date || null,
          
          description: payload.description,
          joinByDate: payload.joinByDate,
          logo: payload.logo,
          orgName: payload.orgName,
          reward: payload.reward,
          studyInstructions: payload.studyInstructions,
          studyName: payload.studyName,
          termsLink: payload.termsLink,
          useOfData: payload.useOfData,
          
          emailReminders: payload.emailReminders,
          missionReminders: payload.missionReminders,
          st: payload.st,
          missionReminders_root: payload.missionReminders_root,
          welcomEmailReminder: payload.welcomEmailReminder,
          
          endOfStudyConditions: payload.endOfStudyConditions,
          userRequiredDevices: payload.userRequiredDevices,
          dataConnections: payload.dataConnections,
          licenses: payload.licenses,
        }

        axios
          .post('/admin/aura/studies', apiPayload, {
            headers: {
              Authorization: `${session.idToken.jwtToken}`,
            },
          })
          .then((response) => {
            notification.success({ message: 'Study created successfully' })
            resolve(response.data)
          })
          .catch((err) => {
            const messageText = err?.response?.data || 'Error creating study'
            notification.error({ message: messageText })
            resolve(false)
          })
      })
    })
  }
  if (cognitoUser != null) return getCurrentUser()

  notification.error({ message: 'Not logged in. Please login first.' })
  return false
}

// PUT /admin/aura/studies to update a study
export async function updateViaStudy(payload) {
  const cognitoUser = userPool.getCurrentUser()
  function getCurrentUser() {
    return new Promise((resolve) => {
      cognitoUser.getSession((err, session) => {
        if (err) {
          notification.error({ message: 'Session expired. Please login again.' })
          resolve(false)
          return
        }

        const apiPayload = {
          studyId: payload.study_id,
          companyCode: payload.int_ref || '',
          complete: payload.complete === 1,
          startDate: payload.start_date || null,
          endDate: payload.end_date || null,

          description: payload.description,
          joinByDate: payload.joinByDate,
          logo: payload.logo,
          orgName: payload.orgName,
          reward: payload.reward,
          studyInstructions: payload.studyInstructions,
          studyName: payload.studyName,
          termsLink: payload.termsLink,
          useOfData: payload.useOfData,
          
          emailReminders: payload.emailReminders,
          missionReminders: payload.missionReminders,
          st: payload.st,
          missionReminders_root: payload.missionReminders_root,
          welcomEmailReminder: payload.welcomEmailReminder,
          
          endOfStudyConditions: payload.endOfStudyConditions,
          userRequiredDevices: payload.userRequiredDevices,
          dataConnections: payload.dataConnections,
          licenses: payload.licenses,
        }

        axios
          .put('/admin/aura/studies', apiPayload, {
            headers: {
              Authorization: `${session.idToken.jwtToken}`,
            },
          })
          .then((response) => {
            notification.success({ message: 'Study updated successfully' })
            resolve(response.data)
          })
          .catch((error) => {
            notification.error({
              message: 'Error updating study',
              description: error?.response?.data || error.message,
            })
            resolve(false)
          })
      })
    })
  }
  if (cognitoUser != null) return getCurrentUser()

  notification.error({ message: 'Not logged in. Please login first.' })
  return false
}

// DELETE /admin/aura/studies
export async function deleteViaStudy(payload) {
  const cognitoUser = userPool.getCurrentUser()
  function getCurrentUser() {
    return new Promise((resolve) => {
      cognitoUser.getSession((err, session) => {
        if (err) {
          notification.error({ message: 'Session expired. Please login again.' })
          resolve(false)
          return
        }

        const apiPayload = {
          studyId: payload.study_id
        }

        axios
          .delete('/admin/aura/studies', {
            headers: {
              Authorization: `${session.idToken.jwtToken}`,
            },
            params: apiPayload,
          })
          .then((response) => {
            notification.success({ message: 'Study deleted successfully' })
            resolve(response.data)
          })
          .catch((err) => {
            const messageText = err?.response?.data || 'Error deleting study'
            notification.error({ message: messageText })
            resolve(false)
          })
      })
    })
  }
  if (cognitoUser != null) return getCurrentUser()

  notification.error({ message: 'Not logged in. Please login first.' })
  return false
}